import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Divider from '@src/components/Divider';
import { H2 } from '@src/components/Typography';
import { idKeyExtractor, padding } from '@src/configuration/constants';
import { Page } from '@src/database/models';

export const List = styled(FlatList as new () => FlatList<Page>).attrs(() => ({
  initialNumToRender: 20,
  maxToRenderPerBatch: 20,
  scrollEventThrottle: 16,
  keyExtractor: idKeyExtractor,
  ItemSeparatorComponent: Divider,
  contentContainerStyle: {
    paddingHorizontal: padding,
    paddingBottom: padding,
  },
}))``;

export const Row = styled.View`
  flex-direction: row;
  align-items: center;
  padding: ${padding}px;
`;

export const CH2 = styled(H2)`
  text-align: center;
`;
